import React from 'react'
import ProductBox from "./ProductBox";
import ProductLoader from "./ProductLoader";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Box from '@material-ui/core/Box';
const number = [1, 2, 3, 4, 5, 6];
const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
    }
};

const ProductCarousel = ({ products, lang, loading }) => {

    try {

        return (
            <div style={{ direction: 'ltr' }}>
                <Carousel responsive={responsive}>
                    {(loading) ? (
                        (number.map((i) => (
                            <div style={{ direction: 'rtl' }}>
                                <Box m={1}>
                                    <ProductLoader lang={lang} />
                                </Box>
                            </div>
                        )))
                    ) : (
                        (products.map((product, i) => (
                            <div style={{ direction: 'rtl' }}>
                                <Box m={1}>
                                    <ProductBox product={product} lang={lang} style={{ width: '100%' }} />
                                </Box>
                            </div>
                        )))
                    )}
                </Carousel>

            </div>
        )

    } catch (e) {
        return (
            <h1>ERROR</h1>
        )
    }

};

export default ProductCarousel;
